import React, { useEffect, useState } from 'react'
import photo from "../../../Assets/Images/Vector.svg";
import remove from "../../../Assets/Images/remove.png";
import axios from "axios";
import { newBaseUrl } from "../../../Consts"
import { useNavigate, useParams } from 'react-router-dom';
import { useProjects } from '../../../Context/ProjectsContext';
import { toast, ToastContainer } from 'react-toastify';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';

function EditProjectForm() {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState(0);
    const { isProjectById, getProjectById } = useProjects()
    const [inputs, setInputs] = useState([{ description: '', image: null }]); // Initialize with one empty inp ut
    const [loading, setLoading] = useState(false);

    const { id } = useParams();

    const navigate = useNavigate();

    const handleInputChange = (index, event) => {
        const { name, value, files } = event.target;
        const newInputs = [...inputs];

        if (files && files.length > 0) {
            const file = files[0]; // Only the first file

            // Validate file size
            const maxSizeInBytes = 512 * 1024; // 512KB
            if (file.size > maxSizeInBytes) {
                alert("File size exceeds 512KB. Please upload a smaller file.");
                return; // Exit without updating the state
            }

            // Validate file type (jpg, jpeg, png)
            const allowedTypes = ["image/jpeg", "image/png"];
            if (!allowedTypes.includes(file.type)) {
                alert("Only JPG, JPEG, or PNG files are allowed.");
                return; // Exit without updating the state
            }

            // Store the file and its corresponding image URL
            newInputs[index][name] = file;

            newInputs[index]['image_url'] = URL.createObjectURL(file);
        } else {
            newInputs[index][name] = value;
        }

        setInputs(newInputs);
    };

    const handleAddInput = () => {
        setInputs([...inputs, { description: '', image: null }]);
    };

    const handleRemoveInput = (index) => {
        const newInputs = [...inputs];
        newInputs.splice(index, 1);
        setInputs(newInputs);
    };

    const handleFilesChange = (event) => {
        const files = Array.from(event.target.files);
        const maxSizeInBytes = 1024 * 1024; // 1MB

        // Allowed formats
        const allowedFormats = [
            "image/jpeg", "image/png",
            "video/mp4", "video/quicktime", "video/x-msvideo", "video/webm"
        ];

        // Filter valid files
        const validFiles = files.filter(
            (file) => allowedFormats.includes(file.type) && file.size <= maxSizeInBytes
        );

        if (validFiles.length !== files.length) {
            alert("Only JPG, JPEG, PNG images or MP4, MOV, AVI, WEBM videos under 1MB are allowed.");
        }

        setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);

        event.target.value = null;
    };

    const handleRemoveImage = (indexToRemove, id) => {
        const updatedFiles = selectedFiles.filter((file, index) => index !== indexToRemove);
        setSelectedFiles(updatedFiles);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const maxSizeInBytes = 512 * 1024; // 512KB

            // Validate file size
            if (file.size > maxSizeInBytes) {
                alert("File size exceeds 512KB. Please upload a smaller file.");
                event.target.value = null; // Reset input field
                return; // Exit the function
            }

            // Validate file type (jpg, jpeg, png)
            const allowedTypes = ["image/jpeg", "image/png"];
            if (!allowedTypes.includes(file.type)) {
                alert("Only JPG, JPEG, or PNG files are allowed.");
                event.target.value = null; // Reset input field
                return; // Exit the function
            }

            // If all validations pass, update state with selected file
            setSelectedFile(file);
        }
    };

    useEffect(() => {
        getProjectById(id).then((data) => {

        }).catch((error) => {
            console.error('Error fetching Project by ID:', error);
        });
    }, []);

    useEffect(() => {
        if (isProjectById?.data?.main_project?.status) {
            setSelectedStatus(isProjectById.data.main_project.status);
        }
        if (isProjectById?.data?.main_project?.project_cat_id) {
            setSelectedCategory(isProjectById?.data?.main_project?.project_cat_id);
        }
        if (isProjectById?.data?.main_project?.gallery) {
            setSelectedFiles(isProjectById.data.main_project.gallery);
        }
        if (isProjectById?.data?.main_project?.description) {
            setInputs(isProjectById.data.main_project.description);
        }
    }, [isProjectById]);

    const handleSaveClick = async () => {
        setLoading(true);
        try {
            const body = {
                'title': document.getElementById('title').value,
                'excerpt': document.getElementById('excerpt').value,
                'slug': document.getElementById('slug').value,
                'project_owner': document.getElementById('project_owner').value,
                'area': document.getElementById('area').value,
                'year': document.getElementById('year').value,
                'status': selectedStatus,
                'order': document.getElementById('order').value,
                'project_cat_id': selectedCategory,
                'image': selectedFile,
            };

            if (selectedFiles) {
                body['gallery_images'] = selectedFiles;
            }

            if (inputs.length > 0) {
                const descriptions = inputs.filter(input => input.description || input.image);

                if (descriptions.length > 0) {
                    body['descriptions'] = descriptions;
                }
            }

            const response = await axios.post(`${newBaseUrl}/api/update/project/${id}`, body, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                },
            });
            toast.success('Project updated successfully!', {
                onClose: () => {
                    navigate(`/Projects/AllProjects/${isProjectById?.data?.main_project?.lang_id == 1 ? "en" : "ar"}`, { replace: true });
                    setLoading(false);
                },
            });
        } catch (err) {
            // Check if there are validation errors in the response
            if (err.response && err.response.data && err.response.data.errors) {
                // Loop through each error message and display it
                const errors = err.response.data.errors; // Assuming `errors` is an object or array
                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        errors[key].forEach((message) => {
                            toast.error(message); // Display each error message
                            console.error(message);

                        });
                    }
                }
            } else if (err.response && err.response.data && err.response.data.message) {
                // Display a single error message if available
                toast.error(err.response.data.message);

            } else {
                // Handle other errors
                toast.error("An unexpected error occurred.");
            }
            setLoading(false)
        }
    };

    return (
        <div>
            <ToastContainer autoClose={4000} pauseOnFocusLoss={false} pauseOnHover={false} />
            {(loading || !isProjectById) ? <LoadingOverlay /> :
                <div className="flex justify-start bg-[#fff] rounded-lg py-[50px] px-[50px] h-[100%]">
                    <div className="flex flex-col gap-5 px-[50px]">
                        <div className="flex rounded-lg bg-[#F2F4F7]">
                            <label
                                htmlFor="fileInput"
                                className="flex flex-col items-center justify-center cursor-pointer w-[200px] h-[200px]">
                                <img
                                    src={isProjectById?.data?.main_project?.image_url != null && selectedFile == null ? isProjectById?.data?.main_project?.image_url :
                                        isProjectById?.data?.main_project?.image_url != null && selectedFile != null ? URL.createObjectURL(selectedFile) : photo}
                                    alt="File Upload"
                                    className={selectedFile == null && isProjectById?.data?.main_project?.image_url == null ? "w-[100px] h-[100px]" : "rounded-lg w-[200px] h-[200px]"}
                                />
                                <input
                                    type="file"
                                    id="fileInput"
                                    accept="image/jpeg, image/png" // Restrict selection to jpg, jpeg, png
                                    className="hidden"
                                    onChange={handleFileChange}
                                />
                            </label>
                        </div>
                        <div>
                            <button className="bg-[#0966AE] text-[#fff] rounded-lg py-2 my-3 w-[200px] text-[20px] font-[Cairo]"
                                onClick={handleSaveClick}>
                                Save
                            </button>
                        </div>
                    </div>
                    <div className="scrollable-description px-[50px]" style={{ width: '100%' }}>
                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >

                            Title <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'text'}
                            id={'title'}
                            name={'Title'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type title here`}
                            defaultValue={isProjectById?.data?.main_project?.title}
                            style={{
                                paddingBottom: "8px",
                            }}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Project Owner <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'text'}
                            id={'project_owner'}
                            name={'projectOwner'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type title here`}
                            defaultValue={isProjectById?.data?.main_project?.project_owner}
                            style={{
                                paddingBottom: "8px",
                            }}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Area <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'text'}
                            id={'area'}
                            name={'Area'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type Area here`}
                            defaultValue={isProjectById?.data?.main_project?.area}
                            style={{
                                paddingBottom: "8px",
                            }}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Year <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'text'}
                            id={'year'}
                            name={'Year'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type Year here`}
                            defaultValue={isProjectById?.data?.main_project?.year}
                            style={{
                                paddingBottom: "8px",
                            }}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Category <span className="text-red-500">*</span>
                        </label>

                        <select
                            name="category"
                            id="category"
                            value={selectedCategory != 0 ? selectedCategory : isProjectById?.data?.main_project?.category?.id}
                            onChange={(e) => {
                                setSelectedCategory(e.target.value);
                            }}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 px-2 w-full h-[40px] border-[#DFEAF2] text-[#718EBF]"
                        >
                            {isProjectById?.data?.projectsCategories.map((Project, index) => (
                                <option key={Project.id} value={Project.id}>{Project.name}</option>
                            ))}
                        </select>

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Excerpt
                        </label>

                        <textarea
                            id={'excerpt'}
                            name={'Excerpt'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type excerpt here`}
                            defaultValue={isProjectById?.data?.main_project?.excerpt}
                            style={{
                                height: "80px",
                                paddingBottom: "3rem",
                            }}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Slug <span className="text-red-500">*</span>
                        </label>

                        <input
                            type={'text'}
                            id={'slug'}
                            name={'slug'}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                            placeholder={`Type slug here`}
                            defaultValue={isProjectById?.data?.main_project?.slug}
                            style={{
                                paddingBottom: "8px",
                            }}
                        />

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Status <span className="text-red-500">*</span>
                        </label>

                        <select
                            name="Status"
                            id="status"
                            value={selectedStatus != 0 ? selectedStatus : isProjectById?.data?.main_project?.status}
                            onChange={(e) => {
                                setSelectedStatus(e.target.value);
                            }}
                            className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 px-2 w-full h-[40px] border-[#DFEAF2] text-[#718EBF]"
                        >
                            <option value="1">Publish</option>
                            <option value="2">Draft</option>
                        </select>

                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Order <span className="text-red-500">*</span>
                        </label>

                        <input type={'number'} id={'order'} name={'Order'} className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style" placeholder={`Type order here`} defaultValue={isProjectById?.data?.main_project?.order} style={{ paddingBottom: "8px" }} />
                        <label
                            className="block text-start text-[16px] font-[400] font-[Cairo] pb-1"
                        >
                            Gallery
                        </label>

                        <div className="grid grid-cols-6 gap-y-5 mb-2">
                            <div className="flex items-center w-[150px] h-[150px] lg:w-[150px] lg:h-[150px] justify-center rounded-lg bg-[#F2F4F7]">
                                <label className="flex items-center justify-center cursor-pointer w-[150px] h-[150px]">
                                    <img
                                        src={photo}
                                        alt=""
                                        className={"w-[75px] h-[75px]"}
                                    />
                                    <input
                                        type="file"
                                        accept="image/jpeg, image/png, video/mp4, video/quicktime, video/x-msvideo, video/webm"
                                        className="hidden"
                                        onChange={handleFilesChange}
                                    />
                                </label>
                            </div>
                            {selectedFiles.map((file, index) => {
                                const isVideo =
                                    file?.type?.startsWith("video") ||
                                    file?.file_type === "video" ||
                                    (file?.image_url &&
                                        file.image_url.match(/\.(mp4|mov|avi|webm|mkv)$/i));

                                return (
                                    <div
                                        key={index}
                                        className="flex items-center w-[150px] h-[150px] justify-center rounded-lg bg-[#F2F4F7]"
                                    >
                                        <div className="relative w-[150px] h-[150px] rounded-lg overflow-hidden">
                                            {isVideo ? (
                                                <div className="relative w-full h-full cursor-pointer">
                                                    <video
                                                        src={file?.image_url ? file.image_url : URL.createObjectURL(file)}
                                                        className="w-full h-full object-cover rounded-lg"
                                                        muted
                                                        playsInline
                                                    />
                                                    {/* overlay للتشغيل */}
                                                    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
                                                        <span className="text-white text-3xl">▶</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <img
                                                    src={file?.image_url ? file.image_url : URL.createObjectURL(file)}
                                                    alt="File Upload"
                                                    className="w-full h-full object-cover rounded-lg"
                                                />
                                            )}

                                            {/* زر الحذف */}
                                            <button
                                                className="absolute top-0 left-0 bg-transparent rounded-full p-1 m-2"
                                                onClick={() => handleRemoveImage(index, file?.id)}
                                            >
                                                <img src={remove} alt="Close" className="w-4 h-4" />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className='flex flex-row items-center justify-start pt-2 pb-2'>
                            <label
                                className="block text-start text-[16px] font-[400] font-[Cairo] pb-1 pr-2"
                            >
                                Description
                            </label>
                            <a
                                className="rounded-lg bg-[#148342] text-[#fff] w-[30px] h-[30px] text-[25px] flex items-center justify-center cursor-pointer"
                                onClick={handleAddInput}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5 transform">
                                    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                </svg>
                            </a>
                        </div>
                        <div>
                            {inputs.map((input, index) => (
                                <div key={index} className="flex flex-row items-center justify-center gap-5 pb-3">
                                    <textarea
                                        name="description"
                                        defaultValue={input?.description}
                                        onChange={(event) => handleInputChange(index, event)}
                                        className="border rounded-lg text-[13px] font-[400] font-[Cairo] mb-2 p-2 w-full h-[40px] border-[#DFEAF2] custom-placeholder-style"
                                        placeholder={`Type excerpt here`}
                                        style={{
                                            height: "150px",
                                        }}
                                    />
                                    <div className="flex items-center w-[150px] h-[150px] lg:w-[150px] lg:h-[150px] justify-center rounded-lg bg-[#F2F4F7]">
                                        <label className="flex items-center justify-center cursor-pointer w-[150px] h-[150px]">
                                            <img
                                                src={input.image == null ? photo : input?.image_url != null ? input?.image_url : input?.image_url != null && input.image != null ? URL.createObjectURL(input.image) : null}
                                                alt="File Upload"
                                                className={input.image == null ? "w-[75px] h-[75px]" : "rounded-lg w-[150px] h-[150px] lg:w-[150px] lg:h-[150px]"}
                                            />
                                            <input
                                                type="file"
                                                accept="image/jpeg, image/png" // Restrict selection to jpg, jpeg, png
                                                name="image"
                                                className="hidden"
                                                onChange={(event) => handleInputChange(index, event)}
                                            />
                                        </label>
                                    </div>

                                    {<button className="rounded-lg bg-[#AF1F24] text-[#fff] w-[50px] h-[50px] text-[25px] flex items-center justify-center cursor-pointer"
                                        onClick={() => handleRemoveInput(index)} >-</button>
                                    }
                                </div>

                            ))}

                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default EditProjectForm